<template>
  <button class="rounded text-sm p-1 px-2 h-7">
    <slot />
  </button>
</template>
